var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',{attrs:{"logo":true}},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view',{staticClass:"child"})],1),_c('Divider',{attrs:{"size":"2em"}}),_c('Legal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }